import type { ReactNode, SVGProps } from "react";

export function SparkleIcon(props: SVGProps<SVGSVGElement>): ReactNode {
	return (
		<svg
			fill="none"
			height="16"
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="1.25"
			viewBox="0 0 16 16"
			width="16"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path d="M6.25 1.75 7.5 5.25l3.5 1.25-3.5 1.25L6.25 11.25 5 7.75 1.5 6.5 5 5.25z" />
			<path d="M11.75 9.25l.75 2 2 .75-2 .75-.75 2-.75-2-2-.75 2-.75z" />
		</svg>
	);
}
